import React from 'react';
import { createPortal } from 'react-dom';
import { useNotification } from '../../contexts/NotificationContext';
import Toast from './Toast';
import '../../css/Toast.css';

const ToastContainer = () => {
  const { toasts, hideToast } = useNotification();

  if (toasts.length === 0) {
    return null;
  }

  return createPortal(
    <div className="toast-container" role="region" aria-label="Notifications">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={hideToast}
        />
      ))}
    </div>,
    document.body
  );
};

export default ToastContainer;
